import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Headerdash from "../components/headerdash";
import Footer from "../components/footer";
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

const Sectionedit = () => {
    const {uuid} = useParams();
    const [title, setTitle] = useState('loading...');
    const [details, setDetails] = useState('loading...');
    const [loaded, setLoaded] = useState(false);
    const [savebtn, setSavebtn] = useState('Save');

    useEffect(() => {
        try {
        fetch('https://api.voicecoach.net/detis/'+uuid, { headers: {'Content-Type': 'application/json'} })
        .then(x => x.json())
        .then(jr => {
            setTitle(jr.title);
            setDetails(jr.details);
            setLoaded(true);
        });
        } catch(e) {
                window.location.href = '/login';
            }
    }, [uuid]);
    let sendToSave = () => {
        setSavebtn('Saving... Please wait.');
        fetch('https://api.voicecoach.net/detis/'+uuid, {headers: {'Content-Type':'application/json'},
        body : JSON.stringify({title: title, details: details}), method: 'post', credentials: 'include'})
        .then(re => window.open(`/view/${uuid}`));

    }
    return <>
    <Headerdash />
    {(loaded) ? 
    (<section className="container my-3">
        <div className="row">
            <div className="mx-auto col-8">
    <div className="form-group">
    <input type="text" className="form-control form-control-lg" placeholder="Enter title" value={title} onChange={e => setTitle(e.target.value)} />
    </div>
    <div className="form-group my-2">
    <SunEditor
        setOptions={{ height: 200, buttonList: buttonList.complex }}
        setContents= { details }
        onChange = {(c) => { setDetails(c) }}
    />
    </div>
    <button onClick={() => {sendToSave()}} className="btn btn-primary">{savebtn}</button>
        </div>
        </div>
    </section>) : 'Loading...' }
    <Footer />
    </>

}

export default Sectionedit;